import * as types from './mutation-types'

export const mutations = {
	[types.ADD_NEWS](state, payload) {
		state.articles = payload
	},
	[types.SET_FILTER_LIMIT](state, limit) {
		state.props.limit = limit
	},
	[types.SET_MAX_QUERY_SIZE](state, limit) {
		state.largestQuerySize = limit
	},
	[types.SET_STATUS](state, status) {
		state.status = status
	}
}
